<template>
    <vx-modal :title="$t('MODALS.listInformative.title')">
        <template v-slot:body>
            <div class="filtros flex justify-between items-center">
                <div class="flex w-1/2">
                    <vs-select v-model="originKey" :label="$t('MODALS.listInformative.selectOriginData')" autocomplete class="selectExample w-full" @change="getColumns(originKey)">
                        <vs-select-item :key="index" :value="item.key" :text="item.description" v-for="(item,index) in listOrigins" />
                    </vs-select>
                </div>
                <span>{{$t('MODALS.listInformative.totalRecords')}} {{total_register}}</span>
                <div class="filtro-2">
                    <i class="vs-icon notranslate icon-scale vs-button--icon  feather icon-grid null" style="font-size: 20px"></i>
                </div>
            </div>
            <div class="data w-full flex">
                <div class="fields pl-2 flex justify-between flex-col">
                	<span class="block p-2 text-success">{{$t('MODALS.listInformative.selectField')}}</span>
                    <ul class="mt-2 w-full overflow-auto" style="height: 85%">
                        <li v-for="(campo, index) in columns" style="font-size: 13px" :key="index">
                            <vs-checkbox :disabled="disabled(campo)" color="success" v-model="SelectedColumn" :vs-value="campo">
                                <span class="truncate inline-block" style="width: 120px;">{{campo}}</span>
                            </vs-checkbox>
                        </li>
                    </ul>
                    <div class="flex items-center justify-center py-3">
                        <vs-button :disabled="!(SelectedColumn.length === 2)" color="success" type="border" @click="PreviweData()">
                            {{$t('MODALS.listInformative.btnPreview')}}
                        </vs-button>
                    </div>
                </div>
                <div class="view-table">
                    <div class="content-table">
                        <table style="width: 100%">
                            <thead>
                                <tr>
                                    <th style="min-width: 10px;padding: 6px 6px" v-if="SelectedColumn.length > 0">Item</th>
                                    <th v-for="(item, index) in SelectedColumn" :key="index">{{item}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in muestraTable" :key="index">
                                    <td style="min-width: 12px;padding: 6px 6px; text-align: center">{{index + 1}}</td>
                                    <td class="truncate" v-for="(field, i) in SelectedColumn" :key="i">{{item[field]}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="flex justify-center items-center px-5 mt-3 mb-5 limit">
                        <input-number :disabled="!(SelectedColumn.length === 2)" v-model.number="cantRegister" :min="1" :max="total_register" :label="$t('MODALS.listInformative.limitData')"></input-number>
                    </div>
                </div>

                <div class="config-choice p-3 flex flex-col justify-between fields2">
                    <div>
                        <p>
                            {{$t('MODALS.listInformative.messagges1')}}
                        </p>
                        <div class="px-5 mt-3 mb-5">
                            <vs-select autocomplete class="mt-5 w-full px-2" v-model="selectedEtiqueta">
                                <vs-select-item :key="index" :value="item" :text="item" v-for="(item, index) in SelectedColumn" />
                            </vs-select>

                            <div v-for="(item, index) in muestra" :key="index">
                                <label class="mb-5 block mt-4"><b>{{item}}:</b></label>
                                <hr>
                            </div>
                        </div>
                    </div>

                    <div>
                        <span class="inline-block mb-5 font-bold" >
                            {{$t('MODALS.listInformative.messagges2')}}
                        </span>
                        <div class="flex justify-between items-center mt-5 mb-3">
                            <vs-button :disabled="desableBtn"  color="success" type="border" @click="addItems(0)">{{$t('MODALS.listInformative.btnAdd')}}</vs-button>
                            <vs-button :disabled="dataLength === 0 || desableBtn"  color="success" type="border"  @click="addItems(1)">{{$t('MODALS.listInformative.btnReplace')}}</vs-button>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </vx-modal>
</template>
<script type="text/javascript">
import { mapState, mapMutations } from 'vuex';

import Api from '@/helpers/api.js';
import InputNumber from '../Number.vue';
export default {
	components: { InputNumber },
    data() {
        return {
            SelectedColumn: [],
            originKey: '',
            cantRegister: 9,
            columns: [],
            dataColumns: [],
            selectedEtiqueta: ''
        }
    },
    watch: {
    	activePopup: function(value) {
    		if(!value) this.clearData();
    	}
    },
    methods: {
    	...mapMutations('resource', ['UPDATE_STATE']),
        /**
         * Obtiene las columnas
         */
    	getColumns(originKey) {
    		if(originKey.trim().length > 0) {
                this.SelectedColumn = [];
    			const columns = this.listOrigins.filter(origin => origin.key === originKey);
    			this.columns = columns[0].columns;
    		}
    	},
    	async PreviweData() {
    		try {
    			const result = await this.apiColumns(this.SelectedColumn, this.cantRegister);
    			this.dataColumns =  result.data;
    		}catch(error) {
    			console.log(error)
    		}
    	},
        async addItems(isAdd) {
            await this.PreviweData();
            await this.addItemsToData(isAdd);
        },
    	async addItemsToData(isAdd) {
    		const label = this.selectedEtiqueta;
            const value = this.SelectedColumn.filter(item => item !== label)[0];

            const data = this.dataColumns.map(item => {
                return {
                    label: item[label],
                    value: item[value]
                }
            });

            if(isAdd === 0) {
                const dataQuestion = this.questionsByPage[this.indexQuestion].data;
                this.questionsByPage[this.indexQuestion].data = [...dataQuestion, ...data];
            }else {
                 this.questionsByPage[this.indexQuestion].data = data;
            }

            this.UPDATE_STATE({ key: 'activePopup', value: false});
            this.selectedEtiqueta = '';
    	},
    	async replaceData() {

    	},
    	async apiColumns(SelectedHeaders, limit) {
    		try {
    			const data = {
    				originID: this.originKey,
    				columns: SelectedHeaders,
    				limit: this.cantRegister

    			}
    			const result = await Api.post('/origins/columns',data);
    			return result;
    		} catch(e) {
    			// statements
    			console.log(e);
    		} finally {
    			// statements
    		}
    	},
    	clearData() {
    		this.SelectedColumn = '';
    		this.originKey = '';
    		this.cantRegister = 20;
    		this.columns = [];
    		this.dataColumns = []
    	},

        disabled(campo) {
            if(this.SelectedColumn.length === 2) {
                if(this.SelectedColumn.includes(campo)) return false;
                return true
            }
            return false;
        },
    },
    computed: {
    	...mapState('resource', ['listOrigins', 'indexQuestion', 'questionsByPage', 'activePopup']),
    	question() {
    		return this.questionsByPage[this.indexQuestion];
    	},
    	total_register() {
    		if(this.originKey.trim().length > 0) {
    			const totalRecords = this.listOrigins.filter(origin => origin.key === this.originKey)[0].totalRecords;
    			return totalRecords;
    		}else {
    			return  0;
    		}
    	},
        muestra() {
            if(this.selectedEtiqueta.length > 0) {
                return this.dataColumns.map(item => item[this.selectedEtiqueta]).slice(0,3);
            }else [];

        },
        dataLength() {
            if(this.question.data)  return this.question.data.length;
            return 0;
        },
        desableBtn() {
            return this.selectedEtiqueta.length === 0;
        },
        muestraTable() {
            return this.dataColumns.slice(0,20);
        }
    }
}
</script>

<style type="text/css" scoped>
.filtros {
    border-bottom: 1px solid rgba(110, 110, 110, .2);
    padding: 20px;
}

.data {
    height: calc(502px - 79px);
    /*background: red;*/
}

.fields {
    /*background: blue;*/
    width: 25%;
    height: 100%;
    border-right: 1px solid rgba(110, 110, 110, .2);
}
.fields2 {
     border-left: 1px solid rgba(110, 110, 110, .2);
}



.view-table {
    box-sizing: box-border;
    width: 35%;
    height: 100%;
    overflow: auto;
}

.config-choice {
    /*background: red;*/
    height: 100%;
    width: calc(100% - 35% - 25%)
}


.view-table .content-table {
    height: 78%;
    overflow: auto;
}

.view-table table {
    border-collapse: collapse;
    border: 1px solid rgb(110, 110, 110, .2);
}

.view-table table thead tr th,
.view-table table tbody tr td {
    border: 1px solid rgb(110, 110, 110, .2);
    min-width: 150px;
    height: 30px;
}

.view-table table tbody tr td {
    padding: 6px 10px;
    padding-top: 5px;
    padding-bottom: 3px;
}

</style>
